// src/components/OpenPriceModal.js
import React, { useState } from "react";
import "../styles/OpenPriceModal.css";

const OpenPriceModal = ({ product, onClose, onConfirm }) => {
  // Extraer la primera palabra del nombre del producto
  const prefix = product.name.split(" ")[0] || "Producto";
  const [customPrice, setCustomPrice] = useState("");
  const [customNamePart, setCustomNamePart] = useState("");

  const handleKeyPress = (key) => {
    if (key === "backspace") {
      setCustomPrice((prev) => prev.slice(0, -1));
    } else if (key === "." && customPrice.includes(".")) {
      return; // Evitar múltiples puntos decimales
    } else if (key !== "." && key !== "backspace") {
      setCustomPrice((prev) => prev + key);
    }
  };

  const handleNameChange = (e) => {
    const input = e.target.value;
    if (input.length <= 15) {
      setCustomNamePart(input);
    }
  };

  const handleConfirm = () => {
    const price = parseFloat(customPrice);
    if (isNaN(price) || price <= 0) {
      alert("Por favor, ingrese un precio válido.");
      return;
    }
    if (!customNamePart.trim()) {
      alert("Por favor, ingrese un nombre personalizado para el producto.");
      return;
    }
    // Combinar el prefijo fijo con el nombre personalizado
    const fullName = `${prefix} - ${customNamePart.trim()}`;
    onConfirm({ ...product, price, name: fullName });
    onClose();
  };

  const keyboardButtons = [
    "7", "8", "9",
    "4", "5", "6",
    "1", "2", "3",
    "0", ".", "backspace"
  ];

  return (
    <div className="modal">
      <div className="modal-content">
        <h2>Personalizar {product.name}</h2>
        <label>
          Nombre del producto:
          <div className="name-input-container">
            <span className="name-prefix">{prefix} - </span>
            <input
              type="text"
              value={customNamePart}
              onChange={handleNameChange}
              placeholder="Nombre personalizado"
              className="name-input"
              maxLength={15}
            />
          </div>
        </label>
        <label>
          Precio:
          <input
            type="text"
            value={customPrice}
            readOnly
            placeholder="0.00"
            className="price-input"
          />
        </label>
        <div className="keyboard">
          {keyboardButtons.map((key) => (
            <button
              key={key}
              className={`keyboard-button ${key === "backspace" ? "backspace" : ""}`}
              onClick={() => handleKeyPress(key)}
            >
              {key === "backspace" ? "⌫" : key}
            </button>
          ))}
        </div>
        <div className="modal-buttons">
          <button onClick={handleConfirm} className="confirm-button">Confirmar</button>
          <button onClick={onClose} className="cancel-button">Cancelar</button>
        </div>
      </div>
    </div>
  );
};

export default OpenPriceModal;